import type { JellyIconName, JellyIconVariant } from './jelly-data'
import { JELLY_ICONS } from './jelly-data'

/**
 * The app's icon system — FA Jelly (line) + Jelly Fill, vendored via
 * scripts/generate-jelly-icons.ts. Convention: `line` is the default voice,
 * `fill` marks active/emphasised states (active tab, liked heart, stamps).
 * Brands (instagram/facebook) exist only as `line`.
 */
export function JellyIcon({
  name,
  variant = 'line',
  className = '',
}: {
  name: JellyIconName
  variant?: JellyIconVariant
  className?: string
}) {
  const icon = JELLY_ICONS[name][variant] ?? JELLY_ICONS[name].line
  return (
    <svg
      viewBox={icon.viewBox}
      aria-hidden
      className={className}
      dangerouslySetInnerHTML={{ __html: icon.body }}
    />
  )
}
